import { history } from 'app'

// some random but fixed key
// NOTE: if you change this key and its deployed, all current users will be logged out
export const TOKEN_KEY = 'Y7ADI_IZb_nqKvl_3HnxT_1v8P'
export const USER_KEY = 'wck_i1qzH2i_cl4R5_XlkJXwcki'


export const retrieveToken = () => {
  return localStorage.getItem(TOKEN_KEY)
}

export const saveToken = (token = null) => {
  localStorage.setItem(TOKEN_KEY, token)
}

export const saveUser = (user = {}) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export const retrieveUser = () => {
  let user
  try {
    user =  JSON.parse(localStorage.getItem(USER_KEY))
  } catch (e) {
    return {}
  }
  if (!user) return {}
  return {
    ...user,
    full_name: `${user.first_name} ${user.last_name}`
  }
}

export const logout = (reason = null) => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  history.push('/users/login/')
}

export const login = (token = {}, user = {}) => {
  saveToken(token.key)
  saveUser(user)
}

/*
* Validates if we have a token in localStorage.
*/
export const isAuthenticated = () => {
  const token = retrieveToken()
  return !!token
}



// WEBPACK FOOTER //
// ./src/utils/auth.js